import { memo } from 'react'
import { Stack } from '@maas-components/core'
import { Check } from '@maas-components/icons'
import AddOutlinedIcon from '@material-ui/icons/AddOutlined'
import i18n from 'core/common/i18n'
import { ButtonStyled, ContainerIconDefaultStyled, TypographyStyled } from './style'
import { ISelectionButtonProps } from './types'

const SelectionButton = ({
  label,
  Icon,
  disabled = false,
  onClick,
  isDefault = false,
  ariaLabel,
  selected = false,
}: ISelectionButtonProps) => {
  const renderIconDefault = () => (
    <ContainerIconDefaultStyled className="d-flex align-center justify-center">
      <AddOutlinedIcon fontSize="large" data-testid="default-icon" />
    </ContainerIconDefaultStyled>
  )

  const renderIcon = () => {
    if (!Icon) {
      return renderIconDefault()
    }

    if (typeof Icon === 'string') {
      return <img src={Icon} alt={`${i18n.t('productNew.selectionButton.iconAlt')}`} />
    }

    return <Icon />
  }

  return (
    <ButtonStyled
      className="p-0 w-100 h-100"
      color="primary"
      variant="outlined"
      disabled={disabled}
      onClick={onClick}
      data-testid="selection-button"
      aria-label={ariaLabel}
    >
      <Stack className="h-100 scroll-x-hidden" direction="column">
        <Stack className="w-100 p-2" alignItems="center" justifyContent="center">
          {renderIcon()}
        </Stack>

        <TypographyStyled
          align="left"
          className="px-2 w-100 m-0 d-flex justify-between"
          $isDefault={isDefault}
          selected={selected}
        >
          <span>{label}</span>

          {selected && <Check data-testid="check-icon" />}
        </TypographyStyled>
      </Stack>
    </ButtonStyled>
  )
}

export default memo(SelectionButton)
